<template>
    <b-container fluid>
        <header-buttons
                :buttons="headerButtons"
                @onAddUser="addUser"
        ></header-buttons>
        <b-row>
            <b-col cols="12">
                <admin-table
                        @onResetPasswordItem="resetPassword"
                        @onEditItem="editUser"
                        :key="tablekey">
                </admin-table>
            </b-col>
        </b-row>
        <inter-modal
                title-icon="flaticon-royal-crown-outline-for-a-prince"
                :buttonPrimary="buttonPrimary"
                title="Modifica profilo"
                :visible="showModal"
                @onPrimaryClick="saveUser">
            <admin-user-form
                    ref="adminUserForm"
                    :user="user"></admin-user-form>
        </inter-modal>
    </b-container>
</template>

<script>
    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import AdminTable from "../components/AdminTable";
    import InterModal from "../../../components/modal/InterModal";
    import AdminUserForm from "../forms/AdminUserForm";
    import User from "@/models/User";
    import {mapActions} from 'vuex'

    export default {
        name: "AdminMatchesListView",
        components: {AdminUserForm, InterModal, AdminTable, HeaderButtons},
        data() {
            return {
                headerButtons: [
                    {
                        label: 'Nuovo Admin',
                        onClick: 'onAddUser',
                    }
                ],
                showModal: false,
                buttonPrimary: {
                    label: 'Salva',
                    confirm: true
                },
                tablekey: 1,
                user: Object.assign({}, User),
            }
        },
        mounted() {
            this.$root.$on('bv::modal::hide', () => {
                this.showModal = false;
            })
        },
        methods: {

            ...mapActions({
                adminUserSave: 'adminUserSave',
                authResetPassword: 'authResetPassword'
            }),

            addUser: function () {
                this.user = Object.assign({}, User);
                this.showModal = true;
            },
            editUser: function (user) {
                this.user = Object.assign({}, user);
                this.showModal = true;
            },
            saveUser: function () {
                if (this.$refs.adminUserForm.validate()) {
                    this.adminUserSave(this.user)
                        .then(() => {
                            this.tablekey += 1;
                            this.showModal = false;
                        }).catch(() => {
                        this.$bvToast.toast('Admin non salvato', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                        this.showModal = false;
                    })

                }

            },
            resetPassword: function (user) {
                this.authResetPassword(user)
                    .then(() => {
                        this.$bvToast.toast('Password resettata', {
                            title: 'Success',
                            variant: 'success'
                        });
                    }).catch(() => {
                    this.$bvToast.toast('Password non resettata', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })
            }

        }
    }
</script>

<style scoped>

</style>
